import { createContext, useContext, useEffect, useState } from "react";
import { adminApi, getToken, setToken, clearToken } from "./adminApi";

const Ctx = createContext(null);

export const AdminAuthProvider = ({ children }) => {
  // "checking" | "authed" | "anon"
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!getToken()) {
      setStatus("anon");
      return;
    }
    adminApi
      .me()
      .then(() => setStatus("authed"))
      .catch(() => {
        clearToken();
        setStatus("anon");
      });
  }, []);

  const login = async (password) => {
    const { token } = await adminApi.login(password);
    setToken(token);
    setStatus("authed");
  };

  const logout = () => {
    clearToken();
    setStatus("anon");
  };

  return <Ctx.Provider value={{ status, login, logout }}>{children}</Ctx.Provider>;
};

export const useAdminAuth = () => useContext(Ctx);
